<template>
    <div class="page-tabs-box">
        <div class="title">
            <el-alert type="warning" effect="light" :closable="false">
                <div slot="title">
                    当前众筹：<slot></slot>
                </div>
            </el-alert>
        </div>
        <el-tabs v-model="activeName" @tab-click="clickEvent">
            <el-tab-pane label="基本信息" name="1" :link="`/raise/project/edit/baseInfo/${id}`"></el-tab-pane>
            <el-tab-pane label="回报项设置" name="2" :link="`/raise/project/edit/ticketPrice/${id}`"></el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
export default {
    props:{
        name:{
            type: String,
            default: '1'
        }
    },
    data(){
        return{
            activeName: this.name,
            id: this.$route.params.id
        }
    },
    methods:{
        clickEvent(tab){
            if (tab.$attrs.link) this.$router.push(tab.$attrs.link)
        }
    }
}
</script>

<style lang="scss" scoped>
.title {
    font-size: 20px;
    margin: -20px -20px 10px -20px;
    .el-alert{
        border-radius: 0;
    }
}
.el-tabs {
    // margin-bottom: 10px;

    ::v-deep .el-tabs__header {
        margin-left: -20px;
        margin-right: -20px;
        .el-tabs__nav-wrap {
            padding: 0 20px;
            .el-tabs__item {
                font-size: 16px;
            }
        }
    }
}
</style>